<template>
  <div class="rent">
    <app-header logoLink="/sell/listing" />
    <!-- 搜索栏 -->
    <search-bar :default-content="searchText" @search="reSearch" />
    <div class="main">
      <!-- 筛选栏 -->
      <filter-bar
        ref="filterBar"
        @change="onFilterBarChange"
        @init-data="onGetRemoteFilters"
        type="buy"
      />
      <div class="list-item-wrap">
        <p class="total" v-if="total && currentCity.name">
          <span v-if="currentApiLang === 'zh-CN'">
            已为您找到
            <span class="num">{{ total }}</span>
            套{{ currentCity.name[currentApiLang] }}在售房产
          </span>
          <span v-else>
            Found
            <span class="num">{{ total }}</span>
            sets of properties for sale in
            {{ currentCity.name[currentApiLang] }}
          </span>
        </p>
        <div class="list-item-wrap-inner" v-loading="loading">
          <ItemSell
            class="list-item"
            v-if="list.length"
            v-for="item in list"
            :key="item.id"
            :info="item"
            :img="getCover(item)"
          />
        </div>
        <div class="empty-data" v-if="!list.length && !loading">{{ $t('noData') }}</div>
        <el-pagination
          class="pager"
          v-if="list.length && total >=10"
          background
          :current-page.sync="page"
          :page-size="pageSize"
          layout="pager"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <app-footer />
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import SearchBar from '@/components/rent/SearchBar.vue'
import FilterBar from '@/components/buy/FilterBar.vue'
import ItemSell from '@/components/home/item-sell.vue'
import convertFilterResult from '@/common/convert-filter-result'
import scroll2top from '@/common/scroll2top'

export default {
  data() {
    return {
      currentApiLang: 'en-US',
      resultFrom: 'filter', // filter, search
      loading: false,
      page: Number(this.$route.query.page) || 1,
      pageSize: 10,
      list: [],
      recommandList: [],
      total: 0,
      loadOver: false,
      isSearchInit: false,
      searchText: this.$route.query.q || '',
      queryId: '',
      remoteFilterBarData: {},
      filterResult: {},
      currentCity: {},
    }
  },
  computed: {
    totalPage() {
      if (!this.total) return 1
      return Math.ceil(this.total / this.pageSize)
    },
  },
  components: {
    AppHeader,
    AppFooter,
    SearchBar,
    FilterBar,
    ItemSell,
  },
  created() {
    this.resultFrom = this.searchText ? 'search' : 'filter'
  },
  mounted() {
    this.getFiltedData()
  },
  methods: {
    loadMore() {
      // 进入页面会执行一次
      if (!this.remoteFilterBarData.defaultCity) return // 等待 remoteFilterBarData 获取到之后(主要是获取到城市)才请求列表
      console.log('starting load more...', this.page)
      if (this.resultFrom === 'search') {
        this.goSearch(this.searchText)
      } else {
        this.getFiltedData()
      }
    },
    // 异步获取到筛选栏的数据
    onGetRemoteFilters(remoteFilterBarData) {
      this.remoteFilterBarData = remoteFilterBarData
      this.currentCity = remoteFilterBarData.defaultCity
    },
    getFiltedData() {
      if (this.loading || this.loadOver) return

      const limit = this.pageSize
      const skip = (this.page - 1) * limit
      this.loading = true
      this.resultFrom = 'filter'

      // 将 filterResult 转换为接口可用的参数结构
      const params = convertFilterResult(this.filterResult, 'sell')
      params.limit = limit
      params.skip = skip
      if (this.searchText && this.searchText.length) {
        params.search = this.searchText
      }
      // params.lang = this.$i18n.getStorageLang() === 'zh' ? 'zh-CN' : 'en-US'

      this.$axios({
        url: '/api/v1/client/estate/sell/getSellList',
        method: 'get',
        params,
      })
        .then(res => {
          this.loading = false
          // this.list = this.list.concat(res.docs)
          this.list = res.docs
          this.total = res.total
          this.queryId = res.queryId

          if (this.page >= this.totalPage) {
            this.loadOver = true
            return
          }
          // this.page += 1
        })
        .catch(() => {
          this.loading = false
        })
    },
    goSearch(text) {
      if (this.loading || this.loadOver) return

      const limit = this.pageSize
      const skip = (this.page - 1) * limit
      this.loading = true
      this.resultFrom = 'search'

      // 将 filterResult 转换为接口可用的参数结构
      const params = convertFilterResult(this.filterResult)
      params.limit = limit
      params.skip = skip
      if (text && text.length) {
        params.search = text
      }
      // params.lang = this.$i18n.getStorageLang() === 'zh' ? 'zh-CN' : 'en-US'

      this.$axios({
        url: '/api/v1/client/estate/sell/getSellList',
        method: 'get',
        params,
      })
        .then(res => {
          this.loading = false
          // this.list = this.list.concat(res.docs)
          this.list = res.docs
          this.total = res.total
          this.queryId = res.queryId

          if (this.page >= this.totalPage) {
            this.loadOver = true
            return
          }
          // this.page += 1
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    },
    reSearch(text) {
      this.searchText = text
      this.loading = false
      this.loadOver = false
      this.page = 1
      this.total = 0
      this.list = []
      this.recommandList = []

      this.$router.push({ query: { q: text } }).catch(() => {})

      if (!text) {
        const query = Object.assign({}, this.$route.query)
        delete query.q
        this.$router.replace({ query })

        return this.getFiltedData()
      }

      this.resetFilter()
      this.goSearch(text)
    },
    resetFilter() {
      this.$refs.filterBar.reset(1000000)
    },
    // 首次进入页面会通过接口修改默认城市，
    // 随即触发此处 onFilterBarChange，且 isInitChange 为 true
    onFilterBarChange(result, isInitChange) {
      // console.log('onFilterBarChange entered! isInitChange: ', isInitChange)

      function getCityItemById(cities, cityId) {
        if (!cities || !cityId) return {}
        const c = cities.filter(c => c.id === cityId)
        return c.length ? c[0] : {}
      }

      if (isInitChange) {
        if (this.resultFrom === 'search') {
          this.goSearch(this.searchText)
        }
        if (this.resultFrom === 'filter') {
          this.getFiltedData()
        }
      } else {
        // 手动点击造成的 onFilterBarChange 只会请求 getFiltedData，不进行 search
        this.filterResult = result
        // this.currentCity = getCityItemById(
        //   this.remoteFilterBarData.filter && this.remoteFilterBarData.filter['SELL_CITY'],
        //   result.city[0]
        // )
        this.currentCity = result.city && result.city.length ? result.city[0] : ''
        // if (!this.currentCity.id) this.currentCity = this.remoteFilterBarData.defaultCity
        this.page = 1
        this.list = []
        this.loadOver = false
        this.getFiltedData()
      }
    },
    getCover(item) {
      const gallery = item && item.gallery
      return gallery && gallery.length ? gallery[0].url : ''
    },
  },
  watch: {
    '$store.state.apiLang': {
      immediate: true,
      handler(val) {
        this.currentApiLang = val
      },
    },
    page: {
      immediate: false,
      handler: function(val) {
        const query = Object.assign({}, this.$route.query)
        query.page = val
        if (this.resultFrom === 'filter') delete query.q
        this.$router.replace({ query })
        this.loadMore()
        scroll2top(300)
      },
    },
  },
}
</script>
<style lang="less" scoped>
@import url('../assets/less/var.less');

.main {
  width: @main-content-width;
  margin: 0 auto;
}

.total {
  margin: 40px 0;
  color: rgba(0, 0, 0, 0.5);

  .num {
    color: @theme-color;
  }
}

.list-item-wrap {
  margin: 0 auto;
  padding-bottom: 30px;
  width: @main-content-width;
}

.list-item-wrap-inner {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  min-height: 120px;
}

.load-over-tip {
  margin: 0;
  padding: 40px 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}

.pager {
  text-align: center;
}
</style>
